import React from 'react';
import { getAccountLink } from '../../apis/stripe';
import Modal from '../Modal';

class ValidationStripeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      link: '',
      showLaunchingModal: false,
      isLoadingData: false
    };
  }

  async componentWillMount() {
    const { showLaunchingModal } = this.props;
    this.setState({ isLoadingData: true, showLaunchingModal });
    if (showLaunchingModal) {
      const link = await getAccountLink();
      this.setState({ link, isLoadingData: false });
    }
  }

  async componentWillReceiveProps(props) {
    const { showLaunchingModal } = props;
    this.setState({ isLoadingData: true, showLaunchingModal });
    if (!this.props.showLaunchingModal && showLaunchingModal) {
      const link = await getAccountLink();
      this.setState({ link });
    }
    this.setState({ isLoadingData: false });
  }

  handleClose = () => {
    this.setState({ showLaunchingModal: false });
  };

  handleSubmit = e => {
    const { link } = this.state;
    e.preventDefault();
    if (link) {
      window.location.replace(link);
    }
  };

  render() {
    const { showLaunchingModal, isLoadingData } = this.state;
    return (
      <Modal
        isOpen={showLaunchingModal}
        showCancelBtn
        handleClose={this.props.onClose}
        title='Configuration des données bancaires'
        onClick={e => this.handleSubmit(e)}
        btnTxt='Suivre la redirection'
      >
        <div style={{ maxHeight: '60vh', backgroundColor: '#00000008' }} className='p-3'>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <h5 style={{ textAlign: 'center' }}>
              Pour vous permettre d'utiliser le paiement en ligne, votre compte{' '}
              <a href='https://stripe.com/fr/legal' target='_blank' rel='noreferrer'>
                Stripe
              </a>{' '}
              nécessite d'être configuré, pour cela, merci de suivre le lien de redirection en
              appyant sur le bouton ci-dessous !
            </h5>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ValidationStripeModal;
